import React from 'react';
import './LeasingPage.css';

const LeasingPage = () => {
  return (
    <>
    
    <div className="leasing-container">
      {/* Hero Section */}
      <section className="hero-sectionx">
        <div className="hero-contentx">
          <h1>Lease with us</h1>
          <h2>Hassle-Free Property Leasing in India</h2>
          <p className="hero-subtitle">
            Partner With Property Plateau Realty – Maximize Returns, Minimize Worries
          </p>
          <p>
            Are you a property owner looking to lease your flat, apartment, villa, or commercial space?
            At Property Plateau Realty, we specialize in professional leasing solutions that ensure your property is marketed, managed, and maintained with care, precision, and profitability.
          </p>
          <p>
            We make leasing simple, transparent, and stress-free — so you can earn steady rental income with total peace of mind.
          </p>
          <button className="cta-button">Get Started</button>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="benefits-section">
        <h2 className="section-title">Why Lease with Property Plateau Realty?</h2>
        <div className="benefits-grid">
          <div className="benefit-card">
            <div className="benefit-icon">✓</div>
            <h3>Verified Tenants, Zero Headaches</h3>
            <p>We conduct rigorous background checks, financial verification, and rental profiling to find the right tenant for your property.</p>
          </div>
          <div className="benefit-card">
            <div className="benefit-icon">✓</div>
            <h3>Corporate & NRI Leasing Expertise</h3>
            <p>We handle corporate leases, expat rentals, and NRI landlord services with seamless legal and operational support.</p>
          </div>
          <div className="benefit-card">
            <div className="benefit-icon">✓</div>
            <h3>Best Rental Value & Market Analysis</h3>
            <p>Our team ensures you get maximum rental returns based on real-time market insights and property evaluations.</p>
          </div>
          <div className="benefit-card">
            <div className="benefit-icon">✓</div>
            <h3>End-to-End Leasing Services</h3>
            <p>From property listing and promotion to legal documentation, rent collection, and maintenance — we take care of everything.</p>
          </div>
          <div className="benefit-card">
            <div className="benefit-icon">✓</div>
            <h3>Legally Compliant & Transparent</h3>
            <p>All our lease agreements are RERA-compliant, and we ensure you're protected under Indian rental laws.</p>
          </div>
        </div>
      </section>

      {/* Property Types Section */}
      <section className="property-types">
        <h2 className="section-title">What Types of Properties Can You Lease With Us?</h2>
        <div className="property-grid">
          <div className="property-cardLWU">
            <h3>Residential Apartments</h3>
          </div>
          <div className="property-cardLWU">
            <h3>Independent Houses & Villas</h3>
          </div>
          <div className="property-cardLWU">
            <h3>Studio & Co-living Units</h3>
          </div>
          <div className="property-cardLWU">
            <h3>Retail Outlets & Office Spaces</h3>
          </div>
          <div className="property-cardLWU">
            <h3>Commercial Shops & Warehouses</h3>
          </div>
        </div>
        <p className="property-note">Whether it's a single unit or a full portfolio, we've got you covered.</p>
      </section>

      {/* Process Section */}
      <section className="process-section">
        <h2 className="section-title">Our Process – Easy, Fast & Transparent</h2>
        <div className="process-steps">
          <div className="process-step">
            <div className="step-number">1</div>
            <h3>Schedule a Free Property Evaluation</h3>
          </div>
          <div className="process-step">
            <div className="step-number">2</div>
            <h3>Professional Photoshoot & Listing</h3>
          </div>
          <div className="process-step">
            <div className="step-number">3</div>
            <h3>Promotion Across 20+ Channels</h3>
            <p>(Magicbricks, 99acres, NoBroker & more)</p>
          </div>
          <div className="process-step">
            <div className="step-number">4</div>
            <h3>Tenant Shortlisting & Screening</h3>
          </div>
          <div className="process-step">
            <div className="step-number">5</div>
            <h3>Negotiation & Lease Agreement Drafting</h3>
          </div>
          <div className="process-step">
            <div className="step-number">6</div>
            <h3>Handover & Property Management</h3>
          </div>
        </div>
      </section>

      {/* Additional Services */}
      <section className="services-section">
        <h2 className="section-title">Additional Leasing Services We Offer</h2>
        <div className="services-list">
          <ul>
            <li>High-Visibility Digital Marketing</li>
            <li>Rental Agreement Creation & E-stamping</li>
            <li>Ongoing Maintenance & Repairs</li>
            <li>Rent Collection & Deposit Transfers</li>
            <li>Monthly Reports & Updates for NRIs and Owners</li>
          </ul>
        </div>
      </section>

      {/* Testimonials */}
      <section className="testimonials">
        <h2 className="section-title">What Our Landlords Say</h2>
        <div className="testimonial-cards">
          <div className="testimonial-card">
            <p>"Property Plateau handled everything while I was abroad — from listing to rent collection."</p>
            <p className="testimonial-author">– Mr. Arjun Desai, London</p>
          </div>
          <div className="testimonial-card">
            <p>"Found a corporate tenant for my Pune flat in just 5 days. Hassle-free and professional."</p>
            <p className="testimonial-author">– Mrs. Shalini Patil, Pune</p>
          </div>
        </div>
      </section>

      {/* Locations */}
      <section className="locations-section">
        <h2 className="section-title">Areas We Serve</h2>
        <p>We currently operate in:</p>
        <p className="locations-list">
          Pune, Mumbai, Bangalore, Hyderabad, Delhi NCR, Goa, Ahmedabad, and Chennai
        </p>
        <p className="locations-note">Expanding soon to more cities!</p>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <h2 className="section-title">Lease Your Property with Confidence</h2>
        <p>
          Ready to find quality tenants and earn reliable rental income?
          Let the experts at Property Plateau Realty manage your leasing journey from start to finish.
        </p>
        <div className="contact-info">
          <p>📧 Email: customerservice@propertyplateau.com</p>
          <p>📞 Call/WhatsApp: +91-91560 91640</p>
          <button className="cta-button" >Submit Your Property for Leasing</button>
        </div>
      </section>
    </div>
    </>
  );
};

export default LeasingPage;